import { render, staticRenderFns } from "./InstitutionalPresentation.vue?vue&type=template&id=5c76275a&scoped=true"
var script = {}
import style0 from "./InstitutionalPresentation.vue?vue&type=style&index=0&id=5c76275a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76275a",
  null
  
)

export default component.exports